
import React from "react";

const GuideHeroSection: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-4">
            <span className="text-sm font-medium bg-[#8932c8]/10 text-[#8932c8] px-3 py-1 rounded-full">
              Strategic Leadership
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            AI-Powered XDR Strategy: <span className="text-[#8932c8]">Redefining Cybersecurity Leadership</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            How forward-thinking security leaders are transforming organizational resilience through intelligent automation and strategic AI implementation.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm text-gray-500 mb-8">
            <span>Strategic Guide</span>
            <span>•</span>
            <span>15 min read</span>
            <span>•</span>
            <span>Expert Analysis</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideHeroSection;
